import React, {Component} from 'react';
import './Select.css';

class Select extends Component {
	render() {
		return (
			<select className="Select" onChange={this.props.onChange}>
				{this.props.children}
			</select>
		);
	}
}

export default Select;


// WEBPACK FOOTER //
// ./src/widgets/Select.js